import { View, Image } from '@react-pdf/renderer'
import QRCode from 'qrcode'

import styles from './styles/index.styles'

interface QRCodeBoxProps {
  masterReservationNumber: String
}

const QRCodeBox = ({ masterReservationNumber }: QRCodeBoxProps) => {
  const url = `${window.location.origin}/booking/list/${masterReservationNumber}/vouherPdf`
  const generateQRCode = async () => {
    const data = await QRCode.toDataURL(url)
    return data
  }

  return (
    <View style={styles.mainDiv}>
      <Image source={generateQRCode()} style={styles.qrImage} />
    </View>
  )
}
export default QRCodeBox
